import React from 'react';
import { IconContainer } from './IconContainer';

const DownloadIconBig = () => {
    return (
        <IconContainer aria-label="icon: download">
           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48">
                <path fill="none" d="M0 0h24v24H0z"/>
                <path d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7zM14 9h5l-7 7-7-7h5V3h4v6z" fill="currentColor"/>
           </svg>
        </IconContainer>
    )
}

export { DownloadIconBig };